<template>
  <div>
    <v-skeleton-loader v-if="isLoading" ref="skeleton" type="table" class="mx-auto"></v-skeleton-loader>
    <v-data-table
      :headers="headers"
      :items="alerts"
      class="shadow-xl mx-5 my-5"
      :server-items-length="totalCount"
      :options.sync="options"
      :footer-props="{
        itemsPerPageOptions: [10, 50, 100],
      }"
      :item-class="alertRowClass"
      v-else
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <div class="d-none d-sm-flex">
            <v-toolbar-title>Alerts</v-toolbar-title>
          </div>
          <v-spacer></v-spacer>
          <router-link to="/new-alert" v-if="hasAuth('New Alert')">
            <v-btn color="primary" class="mr-5 text-capitalize" depressed> <v-icon>add</v-icon>NEW ALERT </v-btn>
          </router-link>
        </v-toolbar>
      </template>

      <template v-slot:item.typeLabel="{ item }">
        <v-chip small :color="item.typeColor" text-color="white" class="font-weight-medium">
          {{ item.typeLabel }}
        </v-chip>
      </template>

      <template v-slot:item.scope="{ item }">
        <div class="py-1 alert-scope-cell">
          <div class="text-body-2 font-weight-medium">{{ item.scopePrimary }}</div>
          <div class="text-caption text--secondary mt-1">{{ item.scopeSecondary }}</div>
        </div>
      </template>

      <template v-slot:item.To="{ item }">
        <v-tooltip v-for="(to, index) in item.To" :key="index" bottom color="black">
          <template v-slot:activator="{ on }">
            <v-chip class="ma-1" small color="primary" text-color="white" v-on="on">
              {{ to.Name }}
            </v-chip>
          </template>
          <span>{{ to.Value }}</span>
        </v-tooltip>
      </template>

      <template v-slot:item.action="{ item }">
        <v-tooltip bottom v-if="item.DataTest && !!item.EmailList">
          <template v-slot:activator="{ on }">
            <span v-on="on">
              <v-btn depressed class="mx-1" @click="testMail(item.EmailList)">
                <v-icon size="18">email</v-icon>
              </v-btn>
            </span>
          </template>
          <span>Test Email Now</span>
        </v-tooltip>
        <v-tooltip bottom v-if="item.DataTest && !!item.SlackWebHookUrl">
          <template v-slot:activator="{ on }">
            <span v-on="on">
              <v-btn depressed class="mx-1" @click="testWebHook(item.SlackWebHookUrl)">
                <v-icon size="18">sync_alt</v-icon>
              </v-btn>
            </span>
          </template>
          <span>Test Slack Now</span>
        </v-tooltip>
        <v-tooltip bottom v-if="item.DataTest && !!item.GoogleChatWebHookUrl">
          <template v-slot:activator="{ on }">
            <span v-on="on">
              <v-btn depressed class="mx-1" @click="testWebHook(item.GoogleChatWebHookUrl)">
                <v-icon size="18">sync_alt</v-icon>
              </v-btn>
            </span>
          </template>
          <span>Test Google Chat Now</span>
        </v-tooltip>
        <v-tooltip bottom v-if="item.DataTest && !!item.MicrosoftTeamsWebHookUrl">
          <template v-slot:activator="{ on }">
            <span v-on="on">
              <v-btn depressed class="mx-1" @click="testWebHook(item.MicrosoftTeamsWebHookUrl)">
                <v-icon size="18">sync_alt</v-icon>
              </v-btn>
            </span>
          </template>
          <span>Test Microsoft Teams Now</span>
        </v-tooltip>
        <v-tooltip bottom v-if="item.DataTest && !!item.HypeWebHookUrl">
          <template v-slot:activator="{ on }">
            <span v-on="on">
              <v-btn depressed class="mx-1" @click="testWebHook(item.HypeWebHookUrl)">
                <v-icon size="18">sync_alt</v-icon>
              </v-btn>
            </span>
          </template>
          <span>Test Hype Now</span>
        </v-tooltip>
        <v-tooltip bottom v-if="item.DataTest && !!item.WebHookUrl">
          <template v-slot:activator="{ on }">
            <span v-on="on">
              <v-btn depressed class="mx-1" @click="testWebHook(item.WebHookUrl)">
                <v-icon size="18">sync_alt</v-icon>
              </v-btn>
            </span>
          </template>
          <span>Test Webhook Now</span>
        </v-tooltip>
        <v-tooltip bottom v-if="item.DataEdit">
          <template v-slot:activator="{ on }">
            <v-btn depressed class="mx-1" :to="`/alert/${item.Id}`" v-on="on">
              <v-icon size="18">edit</v-icon>
            </v-btn>
          </template>
          <span>Edit Alert</span>
        </v-tooltip>
        <v-tooltip bottom v-if="item.DataDelete">
          <template v-slot:activator="{ on }">
            <v-btn depressed class="mx-1" @click="deleteAlert(item.Id)" v-on="on">
              <v-icon size="18">delete</v-icon>
            </v-btn>
          </template>
          <span>Delete Alert</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn depressed class="mx-1 alert-table-switch-btn" v-on="on">
              <v-switch
                :loading="item.activeLoading"
                v-model="item.isActive"
                class="my-1 alert-table-switch"
                hide-details
                color="primary"
                :disabled="!item.DataEdit"
                @change="toggleAlert(item)"
              />
            </v-btn>
          </template>
          <span>{{ item.isActive ? "Uyarı aktif" : "Pasif — bildirim gitmez" }}</span>
        </v-tooltip>
      </template>
      <template v-slot:no-data></template>
    </v-data-table>
    <ConfirmDialog />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { FETCH_FILTER_ALERTS } from "../../store/modules/alert";
import { FETCH_SCRIPTS } from "../../store/modules/script";
import Api from "../../api";
import HypeApi from "../../hype/api";
import ConfirmDialog from "../ConfirmDialog";
import { OPEN_DIALOG } from "../../store/modules/confirm";
import { hasActionAuthorization } from "../../authorization";
import { timeAwareFormat } from "../../time";
import { decodeChatflowAlertPayload } from "../../utils/chatflowAlertStorage";
import { buildAlertScopeSummary } from "../../utils/alertListSummary";
import { AlertEnableStatuses, parseAlertEnabled } from "../../store/modules/alert";

export default {
  components: {
    ConfirmDialog,
  },
  data: () => ({
    options: { itemsPerPage: 10, page: 1 },
    workflowRows: [],
    headers: [
      {
        text: "Alert Name",
        align: "left",
        sortable: true,
        value: "Name",
      },
      {
        text: "Type",
        value: "typeLabel",
        sortable: false,
        width: "100px",
      },
      {
        text: "Monitors",
        value: "scope",
        sortable: false,
      },
      {
        text: "To",
        value: "To",
        align: "center",
        sortable: false,
      },
      {
        text: "Created Time",
        value: "createdAt",
      },
      {
        text: "Created By",
        value: "Created.Name",
      },
      {
        text: "Actions",
        value: "action",
        align: "center",
        sortable: false,
      },
    ],
  }),
  watch: {
    options: {
      handler(newVal, oldVal) {
        if (newVal.page != oldVal.page || newVal.itemsPerPage != oldVal.itemsPerPage) {
          this.fetchAlerts({ options: newVal });
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapState("script", {
      scripts: (state) => state.scripts || [],
    }),
    scriptsById() {
      const map = {};
      for (const s of this.scripts) {
        if (s && s.Id) map[s.Id] = s.Name;
      }
      return map;
    },
    workflowsById() {
      const map = {};
      for (const w of this.workflowRows) {
        if (w && w.id != null) map[String(w.id)] = w.name;
      }
      return map;
    },
    ...mapState("alert", {
      totalCount: (state) => state.totalCount,
      isLoading: (state) => state.isLoading,
    }),
    alerts() {
      return this.$store.state.alert.filteredAlerts.map((i) => {
        const scope = buildAlertScopeSummary(i, {
          scriptsById: this.scriptsById,
          workflowsById: this.workflowsById,
        });
        const isActive = parseAlertEnabled(i.Enabled);
        return {
          ...i,
          ...scope,
          isActive,
          activeLoading: false,
          createdAt: timeAwareFormat(i.createdAt || i.updatedAt),
          To: [
            ...(i.EmailList && [{ Name: "Email", Value: i.EmailList }]),
            ...(i.SlackWebHookUrl && [{ Name: "Slack", Value: i.SlackWebHookUrl }]),
            ...(i.GoogleChatWebHookUrl && [{ Name: "Google Chat", Value: i.GoogleChatWebHookUrl }]),
            ...(i.HypeWebHookUrl && [{ Name: "Hype", Value: i.HypeWebHookUrl }]),
            ...(i.MicrosoftTeamsWebHookUrl && [{ Name: "MS Teams", Value: i.MicrosoftTeamsWebHookUrl }]),
            ...(i.WebHookUrl && !String(i.WebHookUrl).startsWith("__ROBBOT_CF__:")
              ? [{ Name: "Webhook", Value: i.WebHookUrl }]
              : []),
            ...(() => {
              const fromCol =
                i.ChatflowChannelId && Array.isArray(i.ChatflowContactIds) && i.ChatflowContactIds.length
                  ? i.ChatflowContactIds
                  : null;
              const decoded = fromCol ? null : decodeChatflowAlertPayload(i.WebHookUrl);
              const cfIds = fromCol || (decoded && decoded.contactIds) || [];
              return cfIds.length ? [{ Name: "Chatflow", Value: `${cfIds.length} rehber alıcısı` }] : [];
            })(),
          ],
        };
      });
    },
  },
  async created() {
    await this.loadLookups();
    this.fetchAlerts({ options: this.options });
  },
  methods: {
    ...mapActions("confirm", {
      confirm: OPEN_DIALOG,
    }),
    ...mapActions("alert", {
      fetchAlerts: FETCH_FILTER_ALERTS,
    }),
    ...mapActions("script", {
      fetchScripts: FETCH_SCRIPTS,
    }),
    async loadLookups() {
      if (!this.scripts.length) {
        try {
          await this.fetchScripts();
        } catch (e) {
          /* ignore */
        }
      }
      try {
        this.workflowRows = (await HypeApi.getWorkflows()) || [];
      } catch (e) {
        this.workflowRows = [];
      }
    },
    alertRowClass(item) {
      return item && !item.isActive ? "alert-row--disabled" : "";
    },
    async toggleAlert(item) {
      if (!item.DataEdit) return;
      item.activeLoading = true;
      const wantActive = item.isActive;
      const prev = !wantActive;
      try {
        const result = await Api.toggleAlert(item.Id);
        const enabledNum =
          result && result.Enabled != null ? result.Enabled : wantActive ? AlertEnableStatuses.ENABLED : AlertEnableStatuses.DISABLED;
        item.isActive = parseAlertEnabled(enabledNum);
        item.Enabled = enabledNum;
        const idx = this.$store.state.alert.filteredAlerts.findIndex((a) => a.Id === item.Id);
        if (idx >= 0) {
          this.$set(this.$store.state.alert.filteredAlerts[idx], "Enabled", enabledNum);
        }
      } catch (e) {
        item.isActive = prev;
        await this.confirm({
          message: (e.response && e.response.data && e.response.data.reason) || e.message || "Durum değiştirilemedi",
          title: "Error",
          showCancelButton: false,
        });
      }
      item.activeLoading = false;
    },
    async deleteAlert(id) {
      (await this.confirm({
        message: "Do you confirm to delete alerts?",
        title: "confirm",
      })) && (await Api.deleteAlert(id));
      this.fetchAlerts({ options: this.options });
    },
    async testMail(mails) {
      await Api.sendTestMail(mails);
      this.confirm({
        message: "A test mail has been sent.",
        title: "information",
        showCancelButton: false,
      });
    },
    async testWebHook(url) {
      await Api.sendTestWebHookMessage(url);
      this.confirm({
        message: "A test message has been sent.",
        title: "information",
        showCancelButton: false,
      });
    },
    hasAuth(action) {
      return hasActionAuthorization(this.$store, "Alerts", action);
    },
  },
};
</script>

<style scoped>
.shadow-xl {
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

>>> tr.alert-row--disabled {
  opacity: 0.55;
}

>>> tr.alert-row--disabled td {
  background: #fafafa !important;
}
.alert-scope-cell {
  max-width: 420px;
  line-height: 1.35;
}

/* Tasks / Workflows ile aynı: gri kutu içinde mor sürgü */
>>> .alert-table-switch-btn {
  min-width: 52px !important;
  height: 36px !important;
  padding: 0 6px !important;
}

>>> .alert-table-switch {
  margin: 0 !important;
  padding: 0 !important;
}

>>> .alert-table-switch .v-input--selection-controls__input {
  margin: 0;
}

>>> .alert-table-switch .v-input--switch__thumb {
  color: #663f5c !important;
  caret-color: #663f5c !important;
}

>>> .alert-table-switch .v-input--switch__track {
  opacity: 1 !important;
  color: #e8dce6 !important;
}

>>> .alert-table-switch.v-input--is-label-active .v-input--switch__track {
  color: #d4b8cc !important;
}
</style>
